import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Add } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import ModalSpZone from '../SpModal/SpZoneModal';
import { useModal } from 'hooks/useModal';
import { WithApp } from 'contexts/appContext';
import { Switch } from '@material-ui/core';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function Zone(props) {
  const classes = useStyles();
  const { supervisor, showNotify, reload, updateState } = props;
  const [model, setOpen] = useModal(); //uso de las funciones del modal

  return (
    <GridItem xs={12}>
      <GridContainer>
        <ModalSpZone
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={reload}
          supervisorId={supervisor.id}
          supervisor={supervisor}
        />
        <GridItem xs={12}>
          <Card>
            <CardHeader icon>
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Listado de Zonas</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                excelName={'Supervisor-zonas-' + supervisor.dni}
                defaultWidth={1200}
                indexRow={[0, 4]}
                widthRow={[100, 5]}
                columns={columns}
                data={
                  supervisor.zones?.map((item, i) => {
                    return {
                      num: (
                        <div className="actions-right">
                          {i + 1}
                          <ButtonDelete
                            entity={'base/supervisor/' + supervisor.id + '/zone'}
                            id={item.id}
                            reload={reload}
                          />
                        </div>
                      ),
                      code: item.code,
                      description: item.description,
                      state: (
                        <Switch
                          checked={item.pivot.state === 'A' ? true : false}
                          onChange={() =>
                            updateState('zone', item.id, {
                              state: item.pivot.state === 'A' ? 'I' : 'A'
                            })
                          }
                          color="secondary"
                        />
                      ),
                      actions: ''
                    };
                  }) || []
                }
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </GridItem>
  );
});
